export const templates = [
  {
    id: "biz-basic",
    name: "Business Website (Basic)",
    description: "A simple, clean brochure site for a small business to showcase services.",
    applyTo: "small-business",
    preset: {
      category: 'small-business',
      subCategory: 'General Services',
      complexity: 'simple',
      database: 'ncb',
      pwaEnabled: false,
      features: ['responsiveDesign', 'animations'],
      pages: ['landing', 'about', 'contact', 'privacy'],
    }
  },
  {
    id: "biz-advanced",
    name: "Business Website (Advanced)",
    description: "An advanced site with a blog, dark mode, and authentication for client areas.",
    applyTo: "small-business",
    preset: {
      category: 'small-business',
      subCategory: 'Professional Services',
      complexity: 'medium',
      database: 'ncb',
      pwaEnabled: true,
      features: ['responsiveDesign', 'animations', 'darkMode', 'auth'],
      pages: ['landing', 'about', 'contact', 'privacy', 'terms'],
    }
  },
  {
    id: "hospitality-booking",
    name: "Hospitality Booking Site",
    description: "A site for hotels or rentals with booking forms and real-time availability.",
    applyTo: "hospitality",
    preset: {
      category: 'hospitality',
      subCategory: 'Hotel',
      complexity: 'complex',
      database: 'ncb',
      features: ['responsiveDesign', 'auth', 'search', 'realTime'],
      pages: ['landing', 'about', 'contact'],
    }
  },
  {
    id: "trades-services",
    name: "Trades / Home Services",
    description: "A practical website for tradespeople to list services and generate leads.",
    applyTo: "trades",
    preset: {
      category: 'trades',
      subCategory: 'Plumber',
      complexity: 'simple',
      database: 'ncb',
      features: ['responsiveDesign'],
      pages: ['landing', 'about', 'contact'],
    }
  },
  {
    id: "coaching-portal",
    name: "Coaching Portal",
    description: "A platform for coaches to manage clients, schedule sessions, and share resources.",
    applyTo: "coaching",
    preset: {
      category: 'coaching',
      subCategory: 'Life Coaching',
      complexity: 'medium',
      database: 'ncb',
      pwaEnabled: true,
      features: ['responsiveDesign', 'auth', 'animations'],
      pages: ['landing', 'about', 'contact'],
    }
  },
  {
    id: "lms-starter",
    name: "LMS Starter",
    description: "A foundational Learning Management System for selling and managing online courses.",
    applyTo: "lms",
    preset: {
      category: 'lms',
      subCategory: 'Online Courses',
      complexity: 'complex',
      database: 'ncb',
      features: ['responsiveDesign', 'auth', 'darkMode'],
      pages: ['landing', 'about', 'contact', 'terms'],
    }
  },
  {
    id: "directory-starter",
    name: "Directory Starter",
    description: "A listing site for businesses, jobs, or real estate with search and filtering.",
    applyTo: "directory",
    preset: {
      category: 'directory',
      subCategory: 'Business Listings',
      complexity: 'medium',
      database: 'ncb',
      features: ['responsiveDesign', 'search', 'auth'],
      pages: ['landing', 'contact', 'privacy'],
    }
  },
  {
    id: "ecommerce-starter",
    name: "E-commerce Starter",
    description: "A basic online store setup with product listings, cart, and user accounts.",
    applyTo: "e-commerce",
    preset: {
      category: 'e-commerce',
      subCategory: 'Fashion',
      complexity: 'complex',
      database: 'ncb',
      pwaEnabled: true,
      features: ['responsiveDesign', 'auth', 'search', 'animations'],
      pages: ['landing', 'contact', 'privacy', 'terms'],
    }
  },
  {
    id: "crm-starter",
    name: "CRM Starter",
    description: "A simple CRM to manage contacts, deals, and projects.",
    applyTo: "crm",
    preset: {
      category: 'crm',
      subCategory: 'Sales CRM',
      complexity: 'complex',
      database: 'ncb',
      features: ['responsiveDesign', 'auth', 'search', 'realTime'],
      pages: ['landing'],
    }
  },
  {
    id: "web-tool-starter",
    name: "Web Tool Starter",
    description: "A landing page and authenticated dashboard for a new SaaS or web utility.",
    applyTo: "web-tool",
    preset: {
      category: 'web-tool',
      subCategory: 'SaaS',
      complexity: 'medium',
      database: 'ncb',
      pwaEnabled: true,
      features: ['responsiveDesign', 'auth', 'darkMode', 'animations'],
      pages: ['landing', 'privacy', 'terms'],
    }
  }
];